// extracted by mini-css-extract-plugin
export var primitiveLabel = "_uy-0";